import { useState } from "react";
import {
  useGridApiContext,
  useGridSelector,
  gridPageSelector,
  gridRowCountSelector,
  gridPageSizeSelector,
} from "@mui/x-data-grid";
import {
  Box,
  Typography,
  Stack,
  Pagination,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import {KeyboardArrowDown as KeyboardArrowDownIcon} from "@mui/icons-material";

const paginationPerPageLabel = "Per Page:";

const ShepPagination = ({
  pageOptions = [15, 30, 50],
  showRowCount = true,
}) => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const pageCount = Math.ceil(rowCount / pageSize);
  // const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  // https://github.com/mui/mui-x/issues/8450

  const [rowPerPageOptions, setRowPerPageOptions] = useState(pageOptions);
  const [selectedRowPerPage, setSelectedRowPerPage] = useState(
    rowPerPageOptions[0]
  );

  const handlePageSizeChange = (size) => {
    setSelectedRowPerPage(size);
    apiRef.current.setPageSize(size);
  };

  const handlePaginationChange = (_, pageNumber) => {
    apiRef.current.setPage(pageNumber - 1);
  };

  return (
    <Box
      sx={{
        borderRadius: "0px 0px 15px 15px",
        border: "1px solid #edeff2",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "5rem",
        width: "100%",
        backgroundColor: "#f1f5f9",
        boxSizing: "border-box",
        fontWeight: 100,
        pl: 2,
        pr: 2,
      }}
    >
      <Stack
        direction={"row"}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {showRowCount && (
          <Typography sx={{ color: "#9a9b9b", paddingRight: "10px" }}>
            {page + 1} of {pageCount} pages
          </Typography>
        )}
        {rowPerPageOptions.length > 1 && (
          <Stack
            direction={"row"}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ color: "var(--dark-border)", paddingLeft: "5px" }}
          >
            <Typography>{paginationPerPageLabel}</Typography>
            <FormControl variant="standard" sx={{ paddingBottom: "3px" }}>
              <InputLabel id="pagination-label-id">
                {paginationPerPageLabel}
              </InputLabel>
              <Select
                value={selectedRowPerPage}
                labelId="pagination-label-id"
                label={paginationPerPageLabel}
                IconComponent={(props) => (
                  <KeyboardArrowDownIcon
                    {...props}
                    style={{ color: "var(--dark-border)" }}
                  />
                )}
                MenuProps={{
                  disablePortal: true, //preserve stacking context to assign z-axis correctly in popups
                }}
                sx={{
                  backgroundColor: "#9a9b9b",
                  "&.MuiInputBase-root": {
                    backgroundColor: "#f1f5f9",
                  },
                  "& .MuiSelect-select": {
                    paddingRight: "20px !important",
                    paddingLeft: "5px !important",
                    color: "var(--dark-border)",
                  },
                  "&:before": {
                    borderBottom: "none",
                  },
                  "&:after": { borderBottom: "none" },
                  "&:hover:not(.Mui-disabled):before": {
                    borderBottom: "none",
                  },
                }}
              >
                {rowPerPageOptions.map((option, index) => (
                  <MenuItem
                    key={index}
                    value={option}
                    onClick={() => handlePageSizeChange(option)}
                  >
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        )}
      </Stack>
      <Pagination
        count={pageCount}
        onChange={handlePaginationChange}
        page={page + 1}
        shape="rounded"
        sx={{
          "& .MuiPaginationItem-root.Mui-selected": {
            color: "var(--default-light)",
            bgcolor: "var(--primary-main)",
          },
          "& .MuiPaginationItem-previousNext": {
            color: "#a0a2a4",
            bgcolor: "#e1ebf2",
          },
        }}
      />
    </Box>
  );
};

export default ShepPagination;
